<template>
    <v-container fill-height class="align-start">
        <v-row no-gutters class="align-self-center mt-10">
            <v-col>
                <loading-overlay :loading="loading"></loading-overlay>
                <v-row class="justify-space-between pa-4 absolute-top align-center" no-gutters>
                    <v-col>
                        <v-row class="align-center" no-gutters>
                            <v-col class="flex-grow-0">
                                <v-img
                                    alt="logo"
                                    src="/svg/logo.svg"
                                    class="align-self-start mb-1"
                                    width="125"
                                    contain
                                ></v-img>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="text-right">
                        <p>
                            <span class="body-2 grey--text text--darken-1 d-none d-sm-inline-flex flex-wrap">Back to</span>
                            <router-link :to="{ name: 'login' }">
                                <v-btn
                                    href="#"
                                    class="px-sm-12 ml-4"
                                    color="primary"
                                    outlined
                                    medium
                                >
                                    Sign in
                                </v-btn>
                            </router-link>
                        </p>
                    </v-col>
                </v-row>
                <v-row class="py-12" align="center" justify="center" no-gutters>
                    <v-col class="form">
                        <v-fade-transition
                            appear
                        >
                            <h1 class="display-1 font-weight-bold primary--text mb-4">Finish Resetting Your Password</h1>
                        </v-fade-transition>
                        <v-fade-transition
                            appear
                        >
                            <h2 class="subtitle-1 mb-8">Almost there!</h2>
                        </v-fade-transition>

                        <v-form
                            @submit.prevent="submitPasswordReset"
                            class="mb-6"
                        >
                            <input
                                required
                                type="hidden"
                                aria-hidden
                                :value="reset.token"
                            />

                            <!-- Email -->
                            <v-text-field
                                autofocus
                                aria-required
                                required
                                type="text"
                                label="Email"
                                name="email"
                                append-icon="mdi-email-outline"
                                background-color="#fcfcfc"
                                color="primary"
                                outlined
                                v-model="reset.email"
                            ></v-text-field>

                            <!-- Password -->
                            <v-text-field
                                aria-required
                                required
                                v-model="reset.password"
                                v-validate="'required|verify-password'"
                                name="password"
                                label="Password"
                                outlined
                                background-color="#fcfcfc"
                                color="primary"
                                :rules="[rules.required, rules.min, rules.regex]"
                                validate-on-blur
                                :append-icon=" passwordVisible ? 'mdi-eye-off' : 'mdi-eye' "
                                @click:append="passwordVisible = !passwordVisible"
                                color:append-icon="primary"
                                :type="passwordVisible ? 'text' : 'password'"
                            ></v-text-field>

                            <!-- Password Confirm -->

                            <v-text-field
                                aria-required
                                required
                                v-model="reset.passwordConfirm"
                                validate-on-blur
                                ref="password-confirmation"
                                name="confirm_password"
                                label="Re-enter Password"
                                outlined
                                background-color="#fcfcfc"
                                color="primary"
                                append-icon="mdi-lock-outline"
                                :error-messages="passwordsMatch ? null : 'Password confirmation does not match'"
                                :type="passwordVisible ? 'text' : 'password'"
                            ></v-text-field>

                            <v-row no-gutters class="align-center">
                                <v-col class="text-right">
                                    <v-btn
                                        class="px-12"
                                        color="primary"
                                        type="submit"
                                        block
                                        dark
                                        depressed
                                        x-large
                                    >
                                        Reset password
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col class="form">
                            <v-row>
                                <v-col class="d-flex justify-space-between align-center">
                                    <a class="caption primary--text font-weight-bold pa-4" href="#">Home</a>
                                    <a
                                        href="https://www.kaoshinetwork.com/terms_of_service.html"
                                        class="caption primary--text font-weight-bold pa-4"
                                        target="_blank"
                                    >
                                        Legal
                                    </a>
                                    <a
                                        href="https://www.kaoshinetwork.com/privacy_policy.html"
                                        target="_blank"
                                        class=" caption primary--text font-weight-bold pa-4"
                                    >
                                        Privacy Policy
                                    </a>
                                </v-col>
                            </v-row>
                            <p class="caption pb-6 mb-8 grey--text">&copy; {{ year }} Kaoshi. All rights reserved. Trademarks and brands are the property of their respective owners.</p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "password-reset-confirm",
        data: data,
        computed: getComputed(),
        methods: getMethods(),
        mounted: mounted
    }

    function data() {
        return {
            rules: {
                required: value => !!value || 'This field is required.',
                min: v => v.length >= 6 || 'Minimum of 6 characters required.',
                regex: v =>  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!#%*?&]{6,}$/.test(v) ||
                'Password must contain one lowercase, one uppercase, one number, and one special character.',
            },
            year: Vue.moment().year(),
            loading: false,
            reset: {
                email: '',
                password: '',
                passwordConfirm: '',
                token:  this.$route.params.resetToken
            },
            loginCredentials: {
                username: null,
                password: null,
            },
            submitIsPressed: false,
            passwordVisible: false,
        }
    }

    function getComputed() {
        return {
            passwordsMatch: passwordsMatch,
        };

        function passwordsMatch() {
            return this.reset.password === this.reset.passwordConfirm;
        }
    }

    function getMethods() {
        return {
            submitPasswordReset: submitPasswordReset,
            login: login,
        }

        function submitPasswordReset() {
            const vm = this;
            vm.submitIsPressed = true;
            vm.loading = true;

            if (this.passwordsMatch) {
                Vue.backendApi().auth().passwordResetConfirm(vm.reset).then(success, error);

                function success(response) {
                    vm.loginCredentials = {
                        username: vm.reset.email,
                        password: vm.reset.password,
                    };

                    vm.login();
                }

                function error(error) {
                    vm.loading = false;
                    vm.$swal({
                        type: 'error',
                        title: 'Error resetting password',
                        text: error
                    });
                }
            } else {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'Error resetting password',
                    text: 'Password confirm does not match'
                });
            }
        }

        /**
         * Login the user.
         *
         * @todo This is a copy/paste from login.vue; fix this at some stage.
         */
        function login() {
            const vm = this;
            vm.loading = true;

            let data = {};

            // let data = {
            //     forceLogout: 'true',
            //     forceLogoutMessage: "Please login with your new credentials.",
            // };

            let credentials = {...data, ...vm.loginCredentials}
            Vue.backendApi().login(credentials).then(loginSuccess, loginError);

            function loginSuccess(response) {
                vm.loading = false;
                let user = response.data.user;
                let token = response.data.token;
                vm.$store.commit('storeUser', user);
                vm.$store.commit('storeAuthToken', token);

                vm.$swal({
                    type: 'success',
                    title: 'Password Reset',
                    text: 'Your password has been reset.'
                });

                if (user.two_factor_verified) {
                    //vm.$auth.loginWithPopup();
                    vm.$swal({
                        type: "error",
                        title: "Let's ask for a 2fa code...",
                        text: "",
                    });
                } else {
                    vm.$router.push({
                        name: 'offers-list'
                    });
                }
            }

            function loginError(error){
                let unverifiedRe = new RegExp("is not verified");

                vm.loading = false;
                if (error.match(unverifiedRe)) {
                    vm.$swal({
                        type: "error",
                        title: "Please Verify Your Account",
                        text: "Your account must be verified before you can use Kaoshi. Please check your e-mail for instructions.",
                    });
                    vm.$router.push({
                        name: "user-confirmation-link-confirm",
                    })

                    return;
                }

                // @todo Figure out a better way to handle this...
                let pleaseLoginRe = new RegExp("Please login with your new credentials\.?");
                if (error.match(pleaseLoginRe)) {
                    vm.$swal({
                        type: "success",
                        title: "Password Reset",
                        text: "Please login with your new credentials.",
                    });

                    vm.$router.push({name: "login"});

                    return;
                }

                vm.$swal({
                    type: "error",
                    title: "Sign in error",
                    text: error,
                });
            }
        }
    }

    function mounted() {
        window.dispatchEvent(new Event('positionBottomButton'));
    }
</script>

<style scoped>
.slogan {
    color:#1a224e;
    font-size: .625rem!important;
    font-weight: 400;
    letter-spacing: .1666666667em!important;
    line-height: 1rem;
    font-family: Roboto,sans-serif!important;
    margin-top: .625rem;
    margin-left: 1rem;
    margin-bottom: 0;
    white-space: nowrap;
}
.form {
    text-align: center;
    max-width: 350px;
}

@media screen and (min-width: 600px) {
    .absolute-top {
        position: fixed;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        max-width: 1300px;
        width: 90%;
    }
}
</style>
